import {
    OBTENER_WIDGETS,
    AGREGAR_WIDGET,
    ELIMINAR_WIDGET,
    ACTUALIZAR_WIDGET,
    WIDGET_ERROR,
    WIDGET_OK,
    WIDGET_ACTUAL,
    OBTENER_WIDGET,
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_WIDGETS:
            return {
                ...state,
                widgets: action.payload,
                loading: false
            }
        case WIDGET_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case WIDGET_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_WIDGET:
            return {
                ...state,
                //widgets: [...state.widgets, action.payload],
                formulario: false,
                errorformulario: false
            }
        case WIDGET_ACTUAL:
            return state

        case ELIMINAR_WIDGET:
            return state
        case ACTUALIZAR_WIDGET:
            return state
               
        case OBTENER_WIDGET:
            return {
                ...state,
                widget: action.payload
            }
        default:
            return state;
    }
}